
import {Component, Mixins, Ref, Watch} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import GenelIslemFormWizard, {GenelIslemEntity} from "@/components/forms/form-wizard/eicrapro/GenelIslemFormWizard.vue";
import {VForm} from "@/types";
import PersonelPicker from "@/components/pickers/PersonelPicker.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import HacizTalepHazirlaForm from "@/components/forms/HacizTalepHazirlaForm.vue";
import {ITask, Task} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import {TaskDurum} from "@/plugins/uyap-plugin/enum/TaskDurum";
import UyapHacizTalepListForm from "@/components/forms/form-wizard/eicrapro/UyapHacizTalepListForm.vue";
import AvukatTalepPicker from "@/components/pickers/uyap/AvukatTalepPicker.vue";
import MahrumiyetInfo from "@/components/infos/eicrapro/MahrumiyetInfo.vue";
import BankaHacziTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/BankaHacziTalepEvrakForm.vue";
import MaasHacziTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/MaasHacziTalepEvrakForm.vue";
import SgkMossipHacziTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/SgkMossipHacziTalepEvrakForm.vue";
import {UyapHacizEvrakTuru} from "@/plugins/uyap-plugin/enum/uyap/evrak/UyapHacizEvrakTuru";
import {AvukatTalepListCevapRow} from "@/plugins/uyap-plugin/uyap/AvukatTalepList";
import TasinirHacizTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/TasinirHacizTalepEvrakForm.vue";
import TasinirHacizTalimatiTalepEvrakForm
  from "@/components/forms/uyap-evrak/haciz-evrak/TasinirHacizTalimatiTalepEvrakForm.vue";
import IhbarnameTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/IhbarnameTalepEvrakForm.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import {dosyaAnahtari} from "@/utils/dosyaAnahtar";
import {AvukatTalepAdresTuru} from "@/components/pickers/uyap/AvukatTalepAdresTuruPicker.vue";
import {ADRES_KODU, tebligatAdresiDegeri, tebligatAdresiYok} from "@/utils/tebligatAdresi";
import {MDB} from "@/plugins/uyap-plugin/MDB";
import {
  MaasHacziSigortaBorclu,
  MaasHacziSigortaDurumu,
  maasHacziSecimleriniTopla,
  maasHacziSigortaDurumu,
  maasHacziVarsayilanGonderilsinMi
} from "@/plugins/uyap-plugin/utils/maasHacziSigortaDurumu";
import {
  TopluHacizHazirlaTaskHandler
} from "@/plugins/uyap-plugin/store/modules/TaskHandler/TopluHacizHazirlaTaskHandler";
import {ProgramPaths} from "@/enum/ProgramPaths";
import NewFormWrapper from "@/components/NewFormWrapper.vue";
import NewFormDialog from "@/components/dialogs/NewFormDialog.vue";
import TopluHacizTalepDuzenleForm from "@/components/eicrapro/TopluHacizTalepDuzenleForm.vue";
import {BankaHacziParamsBankaRow} from "@/plugins/uyap-plugin/uyap/BankaHacziParams";
import {sorguBankalariniBul} from "@/plugins/uyap-plugin/utils/bankaEslestirme";

// Talepler düzenlendikten sonra borçlu, ObjectInputMixin'in düz nesne kopyası olarak geri yazıldığı
// için prototip metotları kaybolabiliyor; bu yüzden isKurum() opsiyonel, isKurumBool yedek.
interface KurumKontroluBorclu {
  isKurum?(): boolean;
  isKurumBool?: boolean;
}

// Banka haczi rozetinin okuduğu borçlu alanları.
interface BankaHacziBadgeBorclu extends KurumKontroluBorclu {
  bankaBilgileri: { message: string, sorguSonucu?: boolean, sorguSonucDVO?: unknown[] };
  haciz?: { bankaHesapHacziParams?: { bankaList?: unknown[] } };
}

@Component({
  computed: {
    MDB() {
      return MDB
    }
  },
  components: {
    TopluHacizTalepDuzenleForm,
    NewFormDialog,
    NewFormWrapper,
    FormWrapper,
    IhbarnameTalepEvrakForm,
    TasinirHacizTalimatiTalepEvrakForm,
    TasinirHacizTalepEvrakForm,
    SgkMossipHacziTalepEvrakForm,
    MaasHacziTalepEvrakForm,
    BankaHacziTalepEvrakForm,
    MahrumiyetInfo,
    AvukatTalepPicker,
    UyapHacizTalepListForm, HacizTalepHazirlaForm, FormDialog, PersonelPicker, GenelIslemFormWizard
  }
})

export default class TopluHacizHazirlaFormWizard extends Mixins(SimpleInputMixin) {
  @Ref('form') readonly form!: VForm;
  @Ref('genelIslemForm') genelIslemForm!: GenelIslemFormWizard;

  // TODO: genel işleme task için ayrı class ekle
  localValue: GenelIslemEntity = new GenelIslemEntity();
  taskDurum = TaskDurum;
  topluHacizDurum = TopluHacizDurum;
  durum: TopluHacizDurum = this.topluHacizDurum.bosta;
  hacizEvrakTuru = UyapHacizEvrakTuru;
  valid = false;
  onFly = false;
  hideNext = false;
  talepler: Array<AvukatTalepListCevapRow> = [];
  message = "";
  ucretliSorguyaDevamEt = false;
  otomatikTalepGonder = false;

  uyapConcurrentDialogOpen = false;
  uyapConcurrentDialogCountdown = 0;
  uyapConcurrentRememberSkip = false;
  concurrentPromptContext: { errorMessage: string; resolve: (action: 'retry' | 'skip') => void } | null = null;
  concurrentCountdownTimer: number | null = null;

  stepperHeaders = [
    "Listelenecek Takipler",
    "Takipleri Seç",
    "Haciz Evraklarını Hazırla",
    "Haciz Evraklarını Gönder",
    "İşlemler Sıraya Alındı"
  ];
  secilenHeaders = [
    {text: "Birim Adı", value: "birimAdi"},
    {text: "Dosya Esas No", value: "dosyaNo"},
    {text: "Açılış Tarihi", value: "dosyaAcilisTarihi"},
    {text: "Dosya Durumu", value: "dosyaDurum"}
    /* {text: "Durum", value: "status", align: 'center'}*/
  ];

  talepDuzenleHeaders = [
    {text: "", value: "select", sortable: false, width: "50"},
    {text: "Dosya", value: "dosya", width: "400"},
    {text: "Borçlu", value: "borclu"},
    {text: "Durum", value: "durum", sortable: false},
    {text: "İşlemler", value: "actions", sortable: false}
  ];

  varsayilanTalepler = {
    bankaHaczi: {
      muafBankaList: [] as BankaHacziParamsBankaRow[],
      hesapList: [],
      evrakAdi: "",
      evrakAdiSTR: "",
      haricAdi: "",
      haricAdiSTR: "",
      tebligTarihi: "",
    },
    maasHaczi: {
      kurumId: 0,
      kurumAdi: "",
      calismaDurumu: null,
      calismaDurumuText: "",
      maasininBirBoluDordu: false,
      alacaklarininTamami: false,
      emekliIkramiyeHaczi: "",
      nafaka: false,
      nafakaTutari: "",
      aciklama: ""
    },
    tasinirHaczi: {
      aciklama: ""
    },
    tasinirHacizTalimati: {
      birimId: "",
      birimAdi: "",
      aciklama: ""
    },
    ihbarname89_1: {
      kisiler: [] as Array<any>,
      tebligatTuru: "",
      tebligatTuruAciklama: "",
      adresTuru: "",
      adresTuruAciklama: "",
      adres: ""
    },
    ihbarname89_2: {
      tebligTarihi: "",
      tebligatTuru: "",
      tebligatTuruAciklama: "",
      adresTuru: "",
      adresTuruAciklama: "",
      adres: ""
    },
    ihbarname89_3: {
      tebligTarihi: "",
      tebligatTuru: "",
      tebligatTuruAciklama: "",
      adresTuru: "",
      adresTuruAciklama: "",
      adres: ""
    }
  }

  async mounted() {
    let hesapList:any = (await this.$uyap.BankaHacziParams().run({})).hesaplar.sort((a, b) => (a.aciklama.localeCompare(b.aciklama)));
    this.varsayilanTalepler.bankaHaczi={
      muafBankaList: [] as BankaHacziParamsBankaRow[],
      hesapList: hesapList,
      evrakAdi: "MZK",
      evrakAdiSTR: "Haciz Müzekkeresi",
      haricAdi: "MAAS",
      haricAdiSTR: "Maaş Hesabı Hariç",
      tebligTarihi: "",
    }
  }

  async setVarsayilanTalep(hacizEvrakTuru: UyapHacizEvrakTuru) {
    this.varsayilanIhbarnameAtlanan = [];
    for (let takip of this.localValue.secilen_takipler) {
      for (let borclu of takip.task.response.borclular) {
        switch (hacizEvrakTuru) {
          case UyapHacizEvrakTuru.banka_haczi:
            await this.setVarsayilanBankaHaczi(borclu);
            break;
          // case UyapHacizEvrakTuru.maas_haczi:
          //   await this.setVarsayilanMaasHaczi(borclu);
          //   break;
          case UyapHacizEvrakTuru.tasinir_haciz:
            this.setVarsayilanTasinirHaczi(borclu);
            break;
          case UyapHacizEvrakTuru.tasinir_haciz_talimati:
            this.setVarsayilanTasinirHacizTalimati(borclu);
            break;
          case UyapHacizEvrakTuru.ihbarname89_1:
            await this.setVarsayilanIhbarname89_1(borclu, takip);
            break;
          // case UyapHacizEvrakTuru.ihbarname89_2:
          //   await this.setVarsayilanIhbarname89_2(borclu);
          //   break;
          // case UyapHacizEvrakTuru.ihbarname89_3:
          //   await this.setVarsayilanIhbarname89_3(borclu);
          //   break;
        }
      }
    }
    this.varsayilanIhbarnameRaporla();
  }

  // Kişi ve kurumda sorguda bulunan bankalar seçilir, muaf bankalar düşülür. UYAP listesinde bulunamayan
  // banka seçilmez; kullanıcı talebi düzenleyip elle seçer. (DEV-3513)
  async setVarsayilanBankaHaczi(borclu: any) {
    let varsayilanBankaHaczi = this.varsayilanTalepler.bankaHaczi;
    let bankalar = (await this.$uyap.BankaHacziParams().run({})).bankalar.sort((a, b) => (a.ilgili.localeCompare(b.ilgili)));
    let muafIdSet = new Set((varsayilanBankaHaczi.muafBankaList || []).map((banka: BankaHacziParamsBankaRow) => banka.ilgiliKisiIlkKisiKurumId));
    let secilecekBorcluBankalar = sorguBankalariniBul(bankalar, borclu.bankaBilgileri?.sorguSonucDVO).eslesen
        .filter((banka) => !muafIdSet.has(banka.ilgiliKisiIlkKisiKurumId));
    borclu.haciz.bankaHesapHacziParams = {
      bankaList: secilecekBorcluBankalar,
      hesapList: varsayilanBankaHaczi.hesapList,
      evrakAdi: varsayilanBankaHaczi.evrakAdi,
      evrakAdiSTR: varsayilanBankaHaczi.evrakAdiSTR,
      haricAdi: varsayilanBankaHaczi.haricAdi,
      haricAdiSTR: varsayilanBankaHaczi.haricAdiSTR,
      tebligTarihi: varsayilanBankaHaczi.tebligTarihi
    }
  }

  // TODO: buranın kurgusu görüşülecek wip
  // async setVarsayilanMaasHaczi(borclu: any){
  //   let varsayilanMaasHaczi = this.varsayilanTalepler.maasHaczi;
  //   if (varsayilanMaasHaczi.calismaDurumu == 0 || varsayilanMaasHaczi.calismaDurumu == 1) {
  //     // todo: kota kullanımını azaltacak bir fonksiyon yaz
  //   }
  // }

  setVarsayilanTasinirHaczi(borclu: any){
    borclu.haciz.tasinirHacizParams = this.varsayilanTalepler.tasinirHaczi.aciklama;
  }

  setVarsayilanTasinirHacizTalimati(borclu: any){
    let varsayilanTasinirHacizTalimati = this.varsayilanTalepler.tasinirHacizTalimati;
    borclu.haciz.tasinirHacizTalimatiParams = {
      aciklama: varsayilanTasinirHacizTalimati.aciklama,
      birimAdi: varsayilanTasinirHacizTalimati.birimAdi,
      birimId: varsayilanTasinirHacizTalimati.birimId
    }
  }

  async setVarsayilanIhbarname89_1(borclu: any, takip: any){
    let varsayilanIhbarname89_1 = this.varsayilanTalepler.ihbarname89_1;
    if (!varsayilanIhbarname89_1.kisiler || varsayilanIhbarname89_1.kisiler.length === 0) return;

    // Eşleştirme kararlı anahtarla (birimId + dosyaNo) yapılır. takip.dosyaId Excel ile
    // yüklenen takiplerde hiç gelmiyor, UYAP listelemesinden gelende ise bayatlıyor.
    // Bir dosyaya birden çok üçüncü şahıs atanabilir.
    const anahtar = dosyaAnahtari(takip);
    let kisiler = varsayilanIhbarname89_1.kisiler.filter((k: any) => k.dosyalar && k.dosyalar.includes(anahtar));
    if (kisiler.length === 0) return;

    // UYAP çağrıları DosyaBul'un tazelediği dosyaId ile yapılmalı; takip.dosyaId
    // listeleme anındaki id ve bu noktada güvenilmez.
    let dosyaId = takip.task?.response?.dosya?.dosyaId || takip.dosyaId;
    if (!dosyaId) {
      this.varsayilanIhbarnameAtlanan.push(takip.dosyaNo + ' - ' + takip.birimAdi);
      console.warn("setVarsayilanIhbarname89_1: dosyaId çözülemedi, varsayılan 3. şahıs atlandı", takip);
      return;
    }

    this.$set(borclu.haciz, 'ihbarname89_1Params', []);

    let tarafList = await this.$uyap.GetDosyaTarafListesiWithTarafRol().run({
      dosyaId: dosyaId,
      islemTuru: 26
    });

    for (let kisi of kisiler) {
      let mevcutTaraf = tarafList.find((t: any) =>
          t.kisiKurumBilgileriDVO?.kisiKurumId === kisi.temelBilgileri?.kisiKurumID ||
          t.guncelKisiKurumId === kisi.temelBilgileri?.kisiKurumID
      );

      if (!mevcutTaraf) {
        try {
          let uyapIslemTur = 5;
          await this.$uyap.DosyaTarafKaydet().run({
            dosyaId: dosyaId,
            uyapIslemTur: uyapIslemTur,
            TarafList: JSON.stringify([kisi])
          });
          tarafList = await this.$uyap.GetDosyaTarafListesiWithTarafRol().run({
            dosyaId: dosyaId,
            islemTuru: 26
          });
          mevcutTaraf = tarafList.find((t: any) =>
              t.kisiKurumBilgileriDVO?.kisiKurumId === kisi.temelBilgileri?.kisiKurumID ||
              t.guncelKisiKurumId === kisi.temelBilgileri?.kisiKurumID
          );
        } catch (e) {
          console.error("DosyaTarafKaydet hatası:", e);
          this.varsayilanIhbarnameAtlanan.push(takip.dosyaNo + ' - ' + takip.birimAdi);
          continue;
        }
      }

      if (!mevcutTaraf) {
        // Kayıt geçtiyse bile taraf listesi henüz yansıtmamış olabiliyor; sessizce
        // düşmesin diye raporlanıyor.
        this.varsayilanIhbarnameAtlanan.push(takip.dosyaNo + ' - ' + takip.birimAdi);
        console.warn("setVarsayilanIhbarname89_1: taraf kayıttan sonra listede bulunamadı", {takip, kisi});
        continue;
      }

      // Adres ancak dosya + 3. şahıs belli olunca çözülebiliyor; varsayılan ayarlarda
      // dosya bağlamı olmadığı için burada, dosya başına sorgulanıyor.
      let adres: string;
      try {
        adres = await this.varsayilanAdresCoz(dosyaId, borclu.kisiKurumId, mevcutTaraf.guncelKisiKurumId, varsayilanIhbarname89_1);
      } catch (e: any) {
        // Teknik hata: doğrulanmamış adresle talep göndermektense bu dosyayı raporla.
        console.error("varsayilanAdresCoz hatası:", e);
        this.varsayilanIhbarnameAtlanan.push(takip.dosyaNo + ' - ' + takip.birimAdi);
        continue;
      }

      borclu.haciz.ihbarname89_1Params.push({
        kisiKurumId: mevcutTaraf.guncelKisiKurumId,
        kurumAdi: kisi.tarafAdi,
        tebligatTuru: varsayilanIhbarname89_1.tebligatTuru,
        tebligatTuruAciklama: varsayilanIhbarname89_1.tebligatTuruAciklama,
        adresTuru: varsayilanIhbarname89_1.adresTuru,
        adresTuruAciklama: varsayilanIhbarname89_1.adresTuruAciklama,
        adres: adres,
        tebligTarihi: "",
        tarafList: ""
      });
    }

    // Sonraki adımdaki 3. şahıs seçim tablosunu besleyen liste, hazırlama görevi içinde
    // BİR KEZ çekiliyor (TopluHacizHazirlaTaskHandler:136) ve buradaki DosyaTarafKaydet'ten
    // önce alınmış oluyor. Tazelenmezse yeni eklenen taraf tabloda hiç görünmüyor ve
    // 3. şahıs sayacı eski değeri gösteriyor. Elimizdeki liste taze dosyaId ile okundu.
    if (takip.task?.response)
      this.$set(takip.task.response, 'ucuncuSahisList', tarafList);
  }

  /**
   * Varsayılan 89-1'de adres alanını dosya başına çözer. Varsayılan ayarlar ekranında
   * dosya bağlamı olmadığı için adres orada sorgulanamıyor; portal da aynı sırayı izliyor:
   * önce getIcraTebligatTalebiAdresSorgula, sonra talebin adres alanı.
   *
   * Sorgu ÜÇÜNCÜ ŞAHIS için yapılır (kayitId), borçlu için değil.
   * Türe göre değer üretimi için bkz. utils/tebligatAdresi.ts
   */
  async varsayilanAdresCoz(dosyaId: string, borcluKisiKurumId: number, ucuncuSahisKisiKurumId: number, varsayilan: any): Promise<string> {
    const kodlar: { [key: number]: string } = {
      [AvukatTalepAdresTuru.E_TEBLIGAT]: ADRES_KODU.E_TEBLIGAT,
      [AvukatTalepAdresTuru.MERNIS]: ADRES_KODU.MERNIS,
      [AvukatTalepAdresTuru.MERSIS]: ADRES_KODU.MERSIS
    };
    const kod = kodlar[varsayilan.adresTuru];
    if (!kod) {
      // YENI elle yazılıyor; VEKILIN_E_TEBLIGAT için sorgu kodu bilinmiyor.
      if (varsayilan.adresTuru != AvukatTalepAdresTuru.YENI)
        console.warn("varsayilanAdresCoz: bu adres türü için sorgu tanımlı değil, elle girilen değer kullanılıyor", varsayilan.adresTuru);
      return varsayilan.adres || '';
    }

    try {
      const cevap = await this.$uyap.GetIcraTebligatTalebiAdresSorgula().run({
        dosyaId: dosyaId,
        kisiKurumId: borcluKisiKurumId,
        kayitId: ucuncuSahisKisiKurumId,
        adresTuru: kod
      });
      return tebligatAdresiDegeri(cevap, kod);
    } catch (e: any) {
      // Kayıt yoksa UYAP errorCode'lu cevap veriyor (UyapRequest:210); teknik hatalar yutulmaz.
      if (e?.errorCode)
        return tebligatAdresiYok(kod);
      throw e;
    }
  }

  // Varsayılan 3. şahsın uygulanamadığı dosyalar; toplu işlem sonunda tek seferde raporlanır.
  varsayilanIhbarnameAtlanan: string[] = [];

  varsayilanIhbarnameRaporla() {
    if (this.varsayilanIhbarnameAtlanan.length === 0) return;
    const dosyalar = Array.from(new Set(this.varsayilanIhbarnameAtlanan));
    this.$toast.warning(
        dosyalar.length + " dosyaya varsayılan 3. şahıs uygulanamadı, elle eklemeniz gerekiyor: " +
        dosyalar.slice(0, 5).join(", ") + (dosyalar.length > 5 ? " ve " + (dosyalar.length - 5) + " dosya daha" : "")
    );
    this.varsayilanIhbarnameAtlanan = [];
  }
  //
  // async setVarsayilanIhbarname89_2(borclu: any){
  //   let varsayilanIhbarname89_2 = this.varsayilanTalepler.ihbarname89_2;
  //
  // }
  //
  // async setVarsayilanIhbarname89_3(borclu: any){
  //   let varsayilanIhbarname89_3 = this.varsayilanTalepler.ihbarname89_3;
  //
  // }

  get showTalepAyar(): boolean {
    let talepAyarItems = [
      this.hacizEvrakTuru.banka_haczi,
      // this.hacizEvrakTuru.maas_haczi,
      this.hacizEvrakTuru.tasinir_haciz,
      this.hacizEvrakTuru.tasinir_haciz_talimati,
      this.hacizEvrakTuru.ihbarname89_1,
      // this.hacizEvrakTuru.ihbarname89_2,
      // this.hacizEvrakTuru.ihbarname89_3
    ];
    let show=false;
    for (const talep of this.talepler) {
      if (talepAyarItems.includes(talep.talepKodu)) {
        show = true;
        break;
      }
    }
    return show;
  }

  @Watch('localValue.secilen_takipler')
  async onSecilenTakiplerChange() {
    console.log("onSecilenTakiplerChange");
    let secilenTakip: any;
    for (secilenTakip of this.localValue.secilen_takipler) {
      if (!secilenTakip.task) {
        // $set şart: takip nesnesi gözlemlendikten sonra eklenen düz property reaktif olmuyor,
        // task.response altındaki değişiklikler (talep düzenleme vb.) ekrana yansımıyor.
        this.$set(secilenTakip, 'task', new Task());
        secilenTakip.task.dosya_esas_no = secilenTakip.dosyaNo;
        secilenTakip.task.birim_adi = secilenTakip.birimAdi;
        secilenTakip.task.task_type_id = TaskTuru.toplu_haciz_hazirla;
        //For excel loading
        if(typeof secilenTakip.birimId != "undefined"){
          try{
            // DosyaBul.dosyaEslestir task.birim_id okuyor; birimId olarak yazılınca
            // kesin birimId eşleştirmesi atlanıp ada göre eşleştirmeye düşülüyordu.
            secilenTakip.task.birim_id = secilenTakip.birimId;
            secilenTakip.task.dosyaAcilisTarihi = new Date(this.$uyapHelper.formatDate(secilenTakip.dosyaAcilisTarihi)).toString();
            secilenTakip.task.dosya_id = secilenTakip.dosyaId;
          }catch (e) {
              console.log("secilen takip hata aldi birimId den ",secilenTakip);
              console.log(e);
          }
        }
        this.input();
      }
    }
    console.log("changed localValue.secilen_takipler",this.localValue.secilen_takipler)
  }

  onStepChange(stepNo: number) {
    if (stepNo == 3)
      this.hideNext = true;
    else
      this.hideNext = false;
  }

  clearConcurrentCountdown() {
    if (this.concurrentCountdownTimer !== null) {
      clearInterval(this.concurrentCountdownTimer);
      this.concurrentCountdownTimer = null;
    }
  }

  showConcurrentDialog(errorMessage: string): Promise<'retry' | 'skip'> {
    return new Promise((resolve) => {
      this.concurrentPromptContext = { errorMessage, resolve };
      this.uyapConcurrentDialogOpen = true;
      this.uyapConcurrentDialogCountdown = 10;
      this.concurrentCountdownTimer = window.setInterval(() => {
        this.uyapConcurrentDialogCountdown--;
        if (this.uyapConcurrentDialogCountdown <= 0) {
          this.clearConcurrentCountdown();
          this.uyapConcurrentDialogOpen = false;
          this.concurrentPromptContext!.resolve('retry');
          this.concurrentPromptContext = null;
        }
      }, 1000);
    });
  }

  onConcurrentDialogAtla() {
    this.clearConcurrentCountdown();
    this.uyapConcurrentDialogOpen = false;
    if (this.concurrentPromptContext) {
      this.concurrentPromptContext.resolve('skip');
      this.concurrentPromptContext = null;
    }
  }

  onConcurrentDialogTekrarDene() {
    this.clearConcurrentCountdown();
    this.uyapConcurrentDialogOpen = false;
    if (this.concurrentPromptContext) {
      this.concurrentPromptContext.resolve('retry');
      this.concurrentPromptContext = null;
    }
  }

  onTalepChange() {
    this.localValue.secilen_takipler.forEach(takip => {
      if (takip.task && (takip.task.status == this.taskDurum.BITTI_BASARILI || takip.task.status == this.taskDurum.BITTI_HATALI))
        takip.task.status = this.taskDurum.SIRADA;
    })
    this.input();
  }

  async createHacizHazirlaTask() {
    if (this.form.validate()) {
      this.onFly = true;
      this.durum = this.topluHacizDurum.hazirlaniyor;
      this.message = "Talepler hazırlanıyor...";
      this.varsayilanIhbarnameAtlanan = [];
      console.log("this.localValue.secilen_takipler",this.localValue.secilen_takipler);
      console.log("Object.entries(this.localValue.secilen_takipler)",Object.entries(this.localValue.secilen_takipler));
      for (let [index, takip] of Object.entries(this.localValue.secilen_takipler)) {
        if(typeof takip.task == "undefined"){
          console.log("TAKIBIN TASKI BULUNAMADI ---- ",takip);
          this.$toast.error("takip bulunamadi atlandi !");
          continue;
        }
        // @ts-ignore
        let task: ITask = takip.task;
        console.log("WORK TASK",task);
        if (typeof task.status == "undefined") {
          task.status = TaskDurum.SIRADA;
        }
        try {
          this.message = (Number(index) + 1) + ". dosyanın talepleri hazırlanıyor.";
          // Yeniden sorgu borçluları sıfırdan kuruyor; kullanıcının maaş haczi seçimi aşağıda geri konur. (DEV-3353)
          const oncekiMaasHacziSecimleri = maasHacziSecimleriniTopla(task.response?.borclular);
          if (task.status == TaskDurum.SIRADA) {
            task.data = {
              hacizParams: this.talepler,
              ucretliSorguyaDevamEt: this.ucretliSorguyaDevamEt
            };
            let handler = new TopluHacizHazirlaTaskHandler();
            let shouldSkip = false;
            let yenidenDene = true;
            while (yenidenDene) {
              try {
                let taskResult = await handler.handle(task);
                task = taskResult;
                task.status = this.taskDurum.BITTI_BASARILI;
                yenidenDene = false;
              } catch (er: any) {
                if (er?.errorCode === 'PRTL_GNL_10001-61') {
                  const action = this.uyapConcurrentRememberSkip
                    ? 'skip'
                    : await this.showConcurrentDialog(er.message);
                  if (action === 'skip') {
                    task.status = this.taskDurum.BITTI_HATALI;
                    task.description  = er.message;
                    yenidenDene = false;
                    shouldSkip = true;
                  }
                } else {
                  task.status = this.taskDurum.BITTI_HATALI;
                  task.description  = er.message;
                  console.log("TopluHacizHazirlaTaskHandler error", er);
                  yenidenDene = false;
                  shouldSkip = true;
                }
              }
            }
            if (shouldSkip) continue;
          }
          this.message = Number(index + 1) + ". dosyanın varsayılan talepleri uygulanıyor."
          for (let borclu of task.response.borclular) {
            borclu.selected = true;
            if (this.talepler.some(t => t.talepKodu == this.hacizEvrakTuru.banka_haczi))
              this.$set(borclu.haciz, 'bankaHacziSelected', true);
            if (this.talepler.some(t => t.talepKodu == this.hacizEvrakTuru.posta_ceki_haciz))
              this.$set(borclu.haciz, 'postaCekiHacziSelected', true);
            if (this.talepler.some(t => t.talepKodu == this.hacizEvrakTuru.tasinir_haciz))
              this.$set(borclu.haciz, 'tasinirHacziSelected', true);
            if (this.talepler.some(t => t.talepKodu == this.hacizEvrakTuru.tasinir_haciz_talimati))
              this.$set(borclu.haciz, 'tasinirHacizTalimatiSelected', true);
            // Kurum borçlunun maaşı olmadığı için maaş haczi talebi gönderilemiyor; bu yüzden
            // kurumda hiç tavsiye edilmiyor. Gönderim tarafındaki kapı "!== false" olduğundan
            // atamayı atlamak yetmez, değer açıkça false yazılmalı.
            // Gerçek kişide aktif SGK kaydı yoksa kapalı gelir, kullanıcı isterse açar. Bu döngü
            // "Talepleri Hazırla"ya her basışta dönüyor: aynı borçlu nesnesinde seçim zaten dolu; talep listesi
            // değişip dosya yeniden sorgulandıysa önceki seçim kisiKurumId ile geri konur. (DEV-3353)
            if (this.talepler.some(t => t.talepKodu == this.hacizEvrakTuru.maas_haczi)) {
              if (this.borcluKurumMu(borclu)) {
                this.$set(borclu.haciz, 'maasHacziSelected', false);
              } else if (borclu.haciz.maasHacziSelected === undefined) {
                const oncekiSecim = oncekiMaasHacziSecimleri.get(borclu.kisiKurumId);
                this.$set(borclu.haciz, 'maasHacziSelected', oncekiSecim !== undefined ? oncekiSecim : maasHacziVarsayilanGonderilsinMi(borclu));
              }
            }
            if (this.talepler.some(t => t.talepKodu == this.hacizEvrakTuru.ihbarname89_1))
              this.$set(borclu.haciz, 'ihbarname89_1Selected', true);
            if (this.talepler.some(t => t.talepKodu == this.hacizEvrakTuru.ihbarname89_2))
              this.$set(borclu.haciz, 'ihbarname89_2Selected', true);
            if (this.talepler.some(t => t.talepKodu == this.hacizEvrakTuru.ihbarname89_3))
              this.$set(borclu.haciz, 'ihbarname89_3Selected', true);
            if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.banka_haczi))
              await this.setVarsayilanBankaHaczi(borclu);
            // if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.maas_haczi))
            //   await this.setVarsayilanMaasHaczi(borclu);
            if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.tasinir_haciz))
              this.setVarsayilanTasinirHaczi(borclu);
            if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.tasinir_haciz_talimati))
              this.setVarsayilanTasinirHacizTalimati(borclu);
            if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.ihbarname89_1))
              await this.setVarsayilanIhbarname89_1(borclu, takip);
            // if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.ihbarname89_2))
            //   await this.setVarsayilanIhbarname89_2(borclu);
            // if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.ihbarname89_3))
            //   await this.setVarsayilanIhbarname89_3(borclu);
          }
          this.message = Number(index + 1) + ". dosyanın talepleri hazır."
        } catch (err) {
          task.status = this.taskDurum.BITTI_HATALI;
          this.message = Number(index + 1) + ". dosyanın talepleri hazırlanırken hata oluştu. (" + err + ")"
          task.description = err.message;
        } finally {
          this.input();
        }
      }
      this.durum = this.topluHacizDurum.hazir;
      this.varsayilanIhbarnameRaporla();
      this.genelIslemForm.nextStep();
      this.onFly = false;
      if (this.otomatikTalepGonder)
        await this.createTask();
    }
  }

  showTalep(talepKod: UyapHacizEvrakTuru): boolean {
    return !!this.talepler.find((talep: AvukatTalepListCevapRow) => (talep.talepKodu == talepKod));
  }

  // Düzenle formu ObjectInputMixin üzerinden borçlunun düz nesne kopyasını geri gönderiyor.
  // Diziye o kopyayı yazarsak DosyaBorclu örneği (isKurum, getAd gibi metotlar) kayboluyor ve
  // rozet render'ı hata verip DOM'u eski değerde bırakıyor. Bu yüzden mevcut örneğin üzerine yazıyoruz.
  borcluGuncelle(borclular: Array<any>, borcluIndex: number, guncelBorclu: any) {
    if (!borclular[borcluIndex] || !guncelBorclu)
      return;
    Object.assign(borclular[borcluIndex], guncelBorclu);
  }

  borcluKurumMu(borclu: KurumKontroluBorclu): boolean {
    return typeof borclu.isKurum === 'function' ? borclu.isKurum() : !!borclu.isKurumBool;
  }

  seciliBankaSayisi(borclu: BankaHacziBadgeBorclu): number {
    return borclu.haciz?.bankaHesapHacziParams?.bankaList?.length || 0;
  }

  // Kişi ve kurum için ortak: seçili banka varsa yeşil, hesap bulunduğu halde seçili banka yoksa (UYAP
  // listesinde yok ya da muaf) turuncu, hesap yoksa kırmızı. Elle seçilen banka da gönderildiği için önce
  // seçime bakılır. (DEV-3513)
  bankaHacziDurumu(borclu: BankaHacziBadgeBorclu): 'secili' | 'elle' | 'yok' {
    if (this.seciliBankaSayisi(borclu) > 0)
      return 'secili';
    return borclu.bankaBilgileri.sorguSonucu && (borclu.bankaBilgileri.sorguSonucDVO?.length || 0) > 0 ? 'elle' : 'yok';
  }

  bankaHacziBadgeContent(borclu: BankaHacziBadgeBorclu): string {
    return {secili: "\u2713", elle: "!", yok: "-"}[this.bankaHacziDurumu(borclu)];
  }

  bankaHacziBadgeColor(borclu: BankaHacziBadgeBorclu): string {
    return {secili: "green", elle: "orange darken-2", yok: "red"}[this.bankaHacziDurumu(borclu)];
  }

  bankaHacziBadgeTooltip(borclu: BankaHacziBadgeBorclu): string {
    let seciliBankaSayisi = this.seciliBankaSayisi(borclu);
    let mesaj = borclu.bankaBilgileri.message || "";
    if (seciliBankaSayisi > 0)
      return seciliBankaSayisi + " banka seçili. " + mesaj;
    if (this.bankaHacziDurumu(borclu) == 'elle')
      return mesaj.replace(/[.\s]*$/, "") + ". Bulunan bankalar muaf ya da UYAP banka listesinde yok; talebi düzenleyip bankaları elle seçiniz.";
    return mesaj;
  }

  // UYAP'in "SGK Haciz" sonucu GSS kaydinda bile "var" dedigi icin sigorta sorgularina bakilir. (DEV-3353)
  maasHacziDurumu(borclu: MaasHacziSigortaBorclu): MaasHacziSigortaDurumu {
    return maasHacziSigortaDurumu(borclu);
  }

  addAllTasinirDosya(data: any, takip: any) {
    takip.task.response.borclular.forEach((borclu: any) => {
      borclu.haciz.tasinirHacizParams = (data);
    });
    this.input();
  }

  addAllTasinirDosyalar(data: any) {
    this.localValue.secilen_takipler.forEach(takip => {
      this.addAllTasinirDosya(data, takip);
    });
  }

  addAllBankaDosya(data: any, takip: any) {
    takip.task.response.borclular.forEach((borclu: any) => {
      if (!borclu.kurumAdi && data.haricAdi == 'BELEDIYE')
        delete data.haricAdi
      else if (borclu.kurumAdi && data.haricAdi == 'MAAS')
        delete data.haricAdi;
      borclu.haciz.bankaHesapHacziParams = data;
    });
    this.input();
  }

  addAllBankaDosyalar(data: any) {
    this.localValue.secilen_takipler.forEach(takip => {
      this.addAllBankaDosya(data, takip);
    })
  }



  async createTask() {
    this.onFly = true;
    let borcluSecildiMi = false;
    let tasks: Array<Task> = [];
    let takip: any;
    for (takip of this.localValue.secilen_takipler.filter(x=>x.task.status == this.taskDurum.BITTI_BASARILI)) {
      for (let borclu of takip.task.response.borclular) {
        let dosya = Object.assign({},takip.task.response.dosya);
        delete dosya.borclular;
        delete borclu.digerTalep;
        delete borclu.tebligat;
        if (borclu.selected) {
          if (borclu.egm?.sorguSonucDVO?.aracBilgileri?.aracList) {
            borclu.egm.sorguSonucDVO.aracBilgileri.aracList.forEach((arac: any) => delete arac.mahrumiyet);
          }
          borcluSecildiMi = true;
          let task: Task = new Task();
          task.dosya_esas_no = takip.dosyaNo;
          task.birim_adi = takip.birimAdi;
          task.birim_id = takip?.birimId;
          task.uyap_dosya_acilis_tarihi = takip.dosyaAcilisTarihi ? new Date(this.$uyapHelper.formatDate(takip.dosyaAcilisTarihi)).toString() : "";
          task.dosya_id = takip.dosyaId;
          task.task_type_id = TaskTuru.toplu_haciz_gonder;
          task.data = {
            dosya: dosya,
            params: takip.task.response.params,
            borclu: borclu
          };
          tasks.push(task);
        }
      }
    }
    if (borcluSecildiMi) {
      let res = await this.$store.dispatch('postTasks', tasks);
      if (this.$store.getters.getAutoPlay)
        await this.$router.push(ProgramPaths.eicrapro + '/haciz-gonder-detay/' + res.data.id);
      else
        await this.$router.push(ProgramPaths.eicrapro + '/islemler');
      this.genelIslemForm.activeStep++;
    } else
      this.$toast.warning('Talep gönderilecek borçlu seçiniz.')
    this.onFly = false;
  }
}

enum TopluHacizDurum {
  bosta = 1,
  hazirlaniyor = 2,
  hazir = 3
}
